import { render, staticRenderFns } from "./Rutinas.vue?vue&type=template&id=fdac8bf2&"
import script from "./Rutinas.vue?vue&type=script&lang=js&"
export * from "./Rutinas.vue?vue&type=script&lang=js&"
import style0 from "./Rutinas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports